module.exports = __webpack_public_path__ + "img/logo-johnfkennedy.b795ba84.png";